import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const bhxh = 1;
export const gplx = 2;
export const dkyxe = 3;
export const mst = 4;
export const bhyt = 5;

export const findApprovalResultByDocType = (headers, params) => {
    let query = buildQuery(params, []);
    query += `&docType=${params.filters.docType.value}`;
    if (params.filters.idNumber.value) {
        query += `&idNumber=${params.filters.idNumber.value?.trim()}`;
    }
    if (params.filters.socialInsuranceCode?.value) {
        query += `&socialInsuranceCode=${params.filters.socialInsuranceCode?.value?.trim()}`;
    }
    if (params.filters.healthInsuranceCode?.value) {
        query += `&healthInsuranceCode=${params.filters.healthInsuranceCode?.value?.trim()}`;
    }
    if (params.filters.documentCodeRegis?.value) {
        query += `&documentCodeRegis=${params.filters.documentCodeRegis?.value?.trim()}`;
    }
    if (params.filters.documentCodeDrive?.value) {
        query += `&documentCodeDrive=${params.filters.documentCodeDrive?.value?.trim()}`;
    }
    if (params.filters.taxCode?.value) {
        query += `&taxCode=${params.filters.taxCode?.value?.trim()}`;
    }
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/documents/approval-result${query}`, {
        headers,
    });
};
